import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element).dropdown({
      direction: 'auto',
      context: '.panel-content',
      onShow: () => {
        $(this.element).find('.item').removeClass('active selected');
      }
    });

    // Call internal function to collapse dropdown before Turbolinks page cache.
    Siepomaga.cleanOnLoad(() => {
      $(this.element).dropdown("hideMenu")
    });
  }
}
